module.exports = __webpack_public_path__ + "media/img/Landing_Page/counsellor-card-e90b966b4e293dfb17dce07eed083da3.png";